const sizeRem = {
  gap: '1rem',
  maxWidth: '74rem'
};

export default sizeRem;